import angular from 'angular';
import 'angular-filter';
import 'angular-ui-router';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import template from './header-games.jade';
import {fetchFullGameAndCallOnNext} from '../util/game-util.js';

export class HeaderGamesController {
  /* @ngInject */
  constructor($state, $stateParams, GamesResource, GamesLimitedResource, currentUser, currentGame, newGame, header, $cacheFactory) {

    this.currentGame = currentGame;
    this.GamesResource = GamesResource;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.header = header;
    this.disposables = [];

    GamesLimitedResource.getList().then(games => {
      this.games = games.filter(g => g.id > 1466); // filter old Simpalex Apps (https://youappi.atlassian.net/browse/PEP-5233)
      this.disposables.push(currentGame.subscribe((game) => {
        if(!game) {
          fetchFullGameAndCallOnNext(GamesResource, currentGame, games[0].id);
        }
      }));
    });

    this.disposables.push(currentGame.subscribe(game => this.game = game));
    this.disposables.push(currentUser.subscribe(user => this.user = user));
    this.disposables.push(newGame.subscribe(game => this.games.push(game)));

    this.disposeObservable = (d) => { d.dispose() };
    this.$onDestroy = () => { _.forEach(this.disposables, (d) => this.disposeObservable(d)) };

  }

  updateCurrentGame(game) {
    this.GamesResource.one(game.id).get()
      .then((game) => {
        this.currentGame.onNext(game);

        let stateName = this.$state.$current.name;
        let stateParams = angular.extend({}, this.$stateParams, {gameId: game.id, preFetchedGame: game});

        if (/app\.segments\.show*/.test(stateName)) {
          this.$state.go('app.segments.index', stateParams);
        } else if (/app\.campaigns\.(show|edit|explore)/.test(stateName)) {
          this.$state.go('app.campaigns.index', stateParams);
        } else {
          this.$state.go(stateName, stateParams);
        }
      });
  }
}

export function HeaderGamesComponent() {
  return {
    template,
    controller: HeaderGamesController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true,
    link: function (scope, element) {
      if (element.next().is('header-timeframe')) {
        element.addClass('c-header-primary__item u-3/5-large-and-up');
      } else {
        element.addClass('c-header-primary__item c-header-primary__item--fill');
      }
    }
  };
};


export default angular.module('header.games', [
  'ui.router',
  'ui.select',
  'angular.filter',
  ServicesModule.name,
  ResourcesModule.name
])
.directive('headerGames', HeaderGamesComponent);


/** WEBPACK FOOTER **
 ** ./src/common/header/header-games.js
 **/